import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Topbar from "../../Layouts/Topbar";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import useAuthStore from "../../hooks/useAuthStore";
import { API } from "../../constants";

const LoginForm = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const { setUser } = useAuthStore();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const res = await fetch(API.CUSTOMER_LOGIN, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (res.ok && data.status === true) {
        setUser(data.data);

        setMessage("Login successful! Redirecting...");
        setTimeout(() => navigate("/dashboard"), 700);
      } else {
        setMessage(data.message || "Invalid credentials.");
      }
    } catch (err) {
      setMessage("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const togglePassword = () => setShowPassword((prev) => !prev);

  return (
    <>
      <Topbar />
      <Header />
      <div className="login-reg-area">
        <Container>
          <div className="login-reg-area-inner">
            <ul className="list-unstyled d-flex gap-3 align-items-center">
              <li>
                <Button className="login-reg-link-btn" as={Link} to="/register">
                  Register
                </Button>
              </li>
            </ul>
            <Row className="gy-4 gx-5 align-items-center">
              <Col md={5} lg={6}>
                <div className="login-img">
                  <img src="assets/images/new-login.png" alt="Login" />
                </div>
              </Col>
              <Col md={7} lg={6}>
                <div className="login-registration-form">
                  <div className="form-title">
                    <h3>Log In</h3>
                  </div>
                  <Form onSubmit={handleSubmit}>
                    {message && (
                      <Alert
                        variant={
                          message.startsWith("Login successful")
                            ? "success"
                            : "danger"
                        }
                      >
                        {message}
                      </Alert>
                    )}
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="User name or Email *"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3 position-relative">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Password *"
                        value={form.password}
                        onChange={handleChange}
                        required
                      />
                      <i
                        className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}
                        onClick={togglePassword}
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          right: "10px",
                          top: "12px",
                        }}
                      ></i>
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <Form.Check type="checkbox" label="Remember me" />
                      <Link to="/forgot-password" className="forget-pass">
                        Forget Password
                      </Link>
                    </div>
                    <Button
                      className="w-100 login-reg-sub"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Log In"
                      )}
                    </Button>
                    <div className="member mt-3">
                      Not a member yet?{" "}
                      <Link to="/register">
                        Click here to Create an Account
                      </Link>
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default LoginForm;
